import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

/*
|---------------------------------------------------------------------
|                             Routes
|---------------------------------------------------------------------
*/

import { AuthContext, AuthProvider } from "./contexts/AuthContext";
import MainLayout from "./layouts/MainLayout";
import NotFound from "./pages/redirects/NotFound";
import Forgot from "./pages/auth/Forgot";
import Reset from "./pages/auth/Reset";
import Denied from "./pages/auth/Denied";
import AuthLayout from "./layouts/AuthLayout";
import Manage from "./pages/manage/Manage";
import Users from "./pages/manage/users/Users";
import MyProfile from "./pages/profile/MyProfile";
import Signin from "./pages/auth/Signin";
import Dashboard from "./pages/home/Dashboard";
import Units from "./pages/manage/units/Units";
import Requests from "./pages/manage/requests/Requests";
import Request from "./pages/manage/requests/Request";
import ByStatus from "./pages/manage/requests/ByStatus";
import Businesses from "./pages/manage/businesses/Businesses";
import Customers from "./pages/manage/customers/Customers";
import  { useContext } from "react";

function App() {
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Routes>
          <Route element={<AuthLayout />}>
            <Route path="/" element={<Signin />} />
            <Route path="/forgot" element={<Forgot />} />
            <Route path="/reset" element={<Reset />} />
            <Route path="/denied" element={<Denied />} />
          </Route>
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/requests" element={<Requests />} />
          </Route>
          <Route element={<MainLayout />}>
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <MyProfile />
                </ProtectedRoute>
              }
            />

            <Route
              path="/manage"
              element={
                <ProtectedRoute>
                  <Manage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customers"
              element={
                <ProtectedRoute>
                  <Customers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/businesses"
              element={
                <ProtectedRoute>
                  <Businesses />
                </ProtectedRoute>
              }
            />
            <Route
              path="/matrix"
              element={
                <ProtectedRoute>
                  <Units />
                </ProtectedRoute>
              }
            />
            <Route
              path="/requests"
              element={
                <ProtectedRoute>
                  <Requests />
                </ProtectedRoute>
              }
            />
            <Route
              path="/requests/:id"
              element={
                <ProtectedRoute>
                  <Request />
                </ProtectedRoute>
              }
            />

            <Route
              path="/requests/status/:status"
              element={
                <ProtectedRoute>
                  <ByStatus />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </QueryClientProvider>
  );
}

function ProtectedRoute({ children }: { children: JSX.Element }) {
  let { token } = useContext(AuthContext);
  let location = useLocation();
  if (!token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
}

export default App;
